// extracted by mini-css-extract-plugin
module.exports = {"related-category":"StepItem_related-category__m1deh","step-by-step-form__item":"StepItem_step-by-step-form__item__XjdlU"};